import React from 'react';

const NavigateNextIcon = (props) => (
  <svg fill="currentColor" preserveAspectRatio="xMidYMid meet" height="12" width="12" viewBox="0 0 8 12" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M-8-6h24v24H-8z" />
      <path fill="currentColor" fillRule="nonzero" d="M2 0L.59 1.41 5.17 6 .59 10.59 2 12l6-6z" />
    </g>
  </svg>
);

export default NavigateNextIcon;
